//React And GLOBAL CSS
import React, { useEffect, useState } from 'react';
import GConf from './AssetsM/generalConf';
import LoadingBar from 'react-top-loading-bar'
import { toast, ToastContainer } from 'react-toastify';


import { getToken , onMessage} from "firebase/messaging";
import { messaging } from "./AssetsM/firebase";

// /*CSS*/
import 'bootstrap-icons/font/bootstrap-icons.css';
import './theme.css';
import "gridjs/dist/theme/mermaid.css";
import 'react-toastify/dist/ReactToastify.css';

//Router & Routes
import { BrowserRouter as Router,Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';
 
import PrintingRouter from './AssetsM/Router/printRouter';

//Login  & Auth
import LogIn from './LogIn/logIn';
import AuthPage from './LogIn/authPage';
//navBar
import NavBar from './Dashboard/navBar'

//Main
import MainPage from './Dashboard/Main/mainPage';

//Commandes
import RequestPage from './Dashboard/Reservations/requestPage';
import RequestInfo from "./Dashboard/Reservations/requestInfo";

//Stock
import StockPage from './Dashboard/Stock/stockPage';
import AddArticleStock from './Dashboard/Stock/addArticle';
import ArticleInfo from "./Dashboard/Stock/articleInfo";
import Familles from "./Dashboard/Stock/famille";
//Facture
import FacturePage from "./Dashboard/Factures/facturePage";
import AjouterFacture from "./Dashboard/Factures/ajoutreFacture";
import FactureInfo from "./Dashboard/Factures/infoFacture";
import EditFacture from "./Dashboard/Factures/editFacture";
import ResumerFactures from './Dashboard/Factures/resumerFactures';
import DemmandesFactures from './Dashboard/Factures/demmandesFactures';

//Camion 
import ControlPage from './Dashboard/Calendrier/calendarPage'
import AjouterCamion from "./Dashboard/Calendrier/ajouterDate";
import CaisseBons from './Dashboard/Calendrier/caisseBons';
import LeftSideCard from './Dashboard/leftSide';
import NotificationsPage from './Dashboard/Notifications/notifPage';
import CommandeTemp from './Printing/System/commande/commandes';
import FactureTemp from './Printing/System/facture/facture';

const SystemLanding = () => {
    /*########### [CONST] ########## */
 
    /*########### [USE EFF] ########## */
    useEffect(() => {
        //CheckAuthentification()
        CheckLogIn()
        
    },[]);

 

    const CheckAuthentification = () =>{
        const AuthenKey = localStorage.getItem(`Salle_AuthKeyISSet`);
        if (!AuthenKey) {
            window.location.href = "/Auth";
        }
    }

    const CheckLogIn = () =>{
        const pidIsSet = localStorage.getItem('PID');
        if (!pidIsSet) {window.location.href = "/login";}
    }

    return (<>
        <NavBar/>
        <br />
        <br />
        <br />
        <div className='row pt-4 m-1'>
                <div className='col-12 col-md-12 col-lg-2'><LeftSideCard /></div>
                <div className='col-12 col-md-12 col-lg-10'><Outlet /></div>
        </div>
        
    </>);
}

function App() {
  //const and variables 
  
   
  const [progress, setProgress] = useState(2)

  //useefeects
  useEffect(() => {
    setProgress(100);
  }, []);


  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    // Customize notification here
    new Notification(payload.notification.title, {
      body: payload.notification.body,
      data: { 
        url: payload.notification.url,
        photo: payload.notification.photo,
      }
    });
  });
  
  //card
  const RedirectingPage = () => {
      const pidIsSet = localStorage.getItem('PID');
      return (<>
          {
              pidIsSet ? <Navigate to='/S/ma'  /> : <Navigate to='/Login'  />
          } 
      </>);
  }
  const NotFound = () =>{
    return (<div className="cpntainer text-danger pt-5 text-center">
            <h1>Page Introuvable 404 </h1>
            <img src='https://assets.ansl.tn/Images/usful/404.svg' width='200px' className='img-responsive ' />
        </div>);
  }

  
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<RedirectingPage />} />
          <Route path="Login" element={<LogIn />} />
          <Route path="Auth" element={<AuthPage />} />
          <Route path="S" exact element={<SystemLanding />} >
              <Route path="" exact element={<MainPage />} />
              <Route path="ma" exact element={<MainPage />} />
              <Route path="rq" exact element={<Outlet />} >
                  <Route path="" exact element={<RequestPage />} />
                  <Route path="info/:CID" exact element={<RequestInfo />} />
                  <Route path="ajouter-c" exact element={<AjouterCamion />} />
                  <Route path="bons" exact element={<CaisseBons />} />
              </Route>
              <Route path="ca" exact element={<Outlet />}>
                  <Route path="" exact element={<ControlPage />} />
                  
              </Route>
              <Route path="sk" exact element={<Outlet />}>
                  <Route path="" exact element={<StockPage />} />
                  <Route path="ajouter" exact element={<AddArticleStock />} />
                  <Route path="famille" exact element={<Familles />} />
                  <Route path="info/:code" exact element={<ArticleInfo />} />
              </Route>
              <Route path="ft" exact element={<Outlet />}>
                  <Route path="" exact element={<FacturePage />} />
                  <Route path="ajouter" exact element={<AjouterFacture />} />
                  <Route path="resumer" exact element={<ResumerFactures />} />
                  <Route path="demandes" exact element={<DemmandesFactures />} />
                  <Route path="modifier/:FID" exact element={<EditFacture />} />
                  <Route path="info/:FID" exact element={<FactureInfo />} />
              </Route>
          
              
              <Route path="notif" exact element={<NotificationsPage />} />     
          </Route>
          <Route path="Pr">
              <Route path="contrat/:CID" element={<CommandeTemp />} />
              <Route path="facture/:FID" element={<FactureTemp />} />
           </Route>
          <Route path="*" element={<NotFound />} />
          <Route path="test" exact element={<iframe src="https://system.abyedh.com/Landing/depot" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none'
            }} allowfullscreen></iframe>} />
        </Routes>   
      </Router>
      <LoadingBar color={GConf.themeColor} progress={progress}  
                //onLoaderFinished={() => setProgress(0)} 
      />
      <ToastContainer />
    </>
    
  );
}

export default App;
